function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCombiBoxBig(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Pfad 2857",
    d: "M36 18A18 18 0 1 1 18 0a18 18 0 0 1 18 18",
    style: {
      fill: "#ff00b1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Vereinigungsmenge 38",
    d: "M10.408 24.007a3 3 0 1 1 3 2.949 2.979 2.979 0 0 1-3-2.949zm.006-12.6L2.455 3.5V0h21.364v3.476h-.006l-7.979 7.844v5.174l-5.42 3.5zm1.019 6.732 3.382-2.182v-4.2h-3.382zm-.345-7.488h3.992l7.291-7.17H3.868zM3.445 2.474H22.8V1H3.445zm19.4 16.714v-5.954h3.028v5.954zm-4.914 0v-5.954h3.029v5.954zm-12.631 0v-5.954h3.026v5.954zm-5.3 0v-5.954h3.027v5.954z",
    transform: "translate(5.066 5.653)",
    style: {
      fill: "#fff",
      stroke: "transparent",
      strokeMiterlimit: 10
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCombiBoxBig);
export default __webpack_public_path__ + "static/media/combi-box-big.2ff7915c80c692de3d65def735d09b4b.svg";
export { ForwardRef as ReactComponent };